import {
  SlTabGroup
} from "./chunk.FX2LFSZJ.js";
import {
  getOffset,
  scrollIntoView
} from "./chunk.XS4D3FDG.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/tab-group/tab-group.ts
var FadvTabGroup = class extends SlTabGroup {
  constructor() {
    super(...arguments);
    this.fluid = false;
  }
  updateFluid() {
    var _a;
    try {
      (_a = this.tabGroup) == null ? void 0 : _a.classList.toggle("tab-group--fluid", this.fluid);
      const tabs = this.getAllTabs(true);
      if (this.fluid) {
        tabs.forEach((tab) => {
          var _a2, _b;
          tab.style.flex = "1";
          tab.style.display = "flex";
          (_b = (_a2 = tab.shadowRoot) == null ? void 0 : _a2.firstElementChild) == null ? void 0 : _b.classList.add("tab--fluid");
        });
      } else {
        tabs.forEach((tab) => {
          var _a2, _b;
          tab.style.flex = "";
          tab.style.display = "";
          (_b = (_a2 = tab.shadowRoot) == null ? void 0 : _a2.firstElementChild) == null ? void 0 : _b.classList.remove("tab--fluid");
        });
      }
    } catch (e2) {
    }
  }
  syncTabsAndPanels() {
    super.syncTabsAndPanels();
    this.updateFluid();
  }
  repositionIndicator() {
    var _a;
    const currentTab = this.getActiveTab();
    if (!currentTab) {
      return;
    }
    const tab = (_a = currentTab.shadowRoot) == null ? void 0 : _a.firstElementChild;
    const width = tab.clientWidth;
    const height = tab.clientHeight;
    const offset = getOffset(tab, this.nav);
    const offsetTop = offset.top + this.nav.scrollTop;
    const offsetLeft = offset.left + this.nav.scrollLeft;
    switch (this.placement) {
      case "top":
      case "bottom":
        this.indicator.style.width = `${width}px`;
        this.indicator.style.height = "auto";
        this.indicator.style.transform = `translateX(${offsetLeft}px)`;
        break;
      case "start":
      case "end":
        this.indicator.style.width = "auto";
        this.indicator.style.height = `${height}px`;
        this.indicator.style.transform = `translateY(${offsetTop}px)`;
        break;
    }
  }
  getAllTabs(includeDisabled = false) {
    var _a;
    const slot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector('slot[name="nav"]');
    if (!slot)
      return [];
    return [...slot.assignedElements()].filter((el) => {
      return includeDisabled ? hasTag(el, "fadv-tab") : hasTag(el, "fadv-tab") && !el.disabled;
    });
  }
  getAllPanels() {
    const slot = this.body.querySelector("slot");
    if (!slot)
      return super.getAllPanels();
    return [...slot.assignedElements()].filter((el) => hasTag(el, "fadv-tab-panel"));
  }
  handleClick(event) {
    const target = event.target;
    const tab = target.closest("fadv-tab");
    const tabGroup = tab == null ? void 0 : tab.closest("fadv-tab-group");
    if (tabGroup !== this) {
      return;
    }
    if (tab) {
      this.setActiveTab(tab, { scrollBehavior: "smooth" });
    }
  }
  handleFocusMove(event) {
    const activeEl = document.activeElement;
    const tabs = this["tabs"];
    if (hasTag(activeEl, "fadv-tab")) {
      let index = tabs.indexOf(activeEl);
      if (event.key === "Home") {
        index = 0;
      } else if (event.key === "End") {
        index = tabs.length - 1;
      } else if (event.key === "ArrowLeft") {
        index = Math.max(0, index - 1);
      } else if (event.key === "ArrowRight") {
        index = Math.min(tabs.length - 1, index + 1);
      }
      tabs[index].focus({ preventScroll: true });
      if (this.activation === "auto") {
        this.setActiveTab(tabs[index], { scrollBehavior: "smooth" });
      }
      if (["top", "bottom"].includes(this.placement)) {
        scrollIntoView(tabs[index], this.nav, "horizontal");
      }
      event.preventDefault();
    }
  }
  handleKeyDown(event) {
    const target = event.target;
    const tab = target.closest("fadv-tab");
    const tabGroup = tab == null ? void 0 : tab.closest("fadv-tab-group");
    if (tabGroup !== this) {
      return;
    }
    if (["Enter", " "].includes(event.key)) {
      if (tab) {
        this.setActiveTab(tab, { scrollBehavior: "smooth" });
        event.preventDefault();
      }
    }
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) {
      this.handleFocusMove(event);
    }
  }
  setActiveTab(tab, options) {
    if (!tab)
      return;
    super.setActiveTab(tab, options);
  }
};
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvTabGroup.prototype, "fluid", 2);
__decorateClass([
  watch("fluid")
], FadvTabGroup.prototype, "updateFluid", 1);
FadvTabGroup = __decorateClass([
  n("fadv-tab-group")
], FadvTabGroup);

export {
  FadvTabGroup
};
